<script>
import {
  mapGetters
}
from 'vuex'
import { IsNullOrEmpty, showURL } from '@/modules/helper/index'
import { IsUserActionAllow, showExternalURL } from "@/modules/helper/index";
import DeviceInfo from '@/modules/util/deviceInfo';
export default {
  props: {
    caption: {
      type: String,
      default: ''
    },
    elementSize: {
      type: String,
      default: 'default' // default, large
    },
    elementStyle: {
      type: String,
      default: 'filled' // filled, outlined
    },
    linkURL: {
      type: String,
      default: ''
    },
    actionType: {
      type: String,
      default: 'NONE'
    }
  },
  computed: {
    ...mapGetters([
      'resource',
      'DesignSettings'
    ]),

    isUserActionAllow() {
      return IsUserActionAllow()
    }
  },
  methods: {
    showMessage() {
      let modalOptions = {
        title: this.resource.warningTitle,
        text: this.resource.warningMessage,
        buttonText: this.resource.closeBtn,
        downloadbuttonText: DeviceInfo.isAndroid
          ? this.resource.AndroidDownload
          : this.resource.AppleDownload,
        $f7: this.$f7
      };
      this.$showModal(modalOptions)
    },
    onClick() {
      if ((this.actionType === 'PHONE' || this.actionType === 'EMAIL') && !this.isUserActionAllow) {
        this.showMessage()
      }
      else if (this.actionType === 'WEBSITE' && !IsNullOrEmpty(this.linkURL)) {
        showURL(this.linkURL, this.DesignSettings.AppThemeColor, this.DesignSettings.AppThemeFontColor)
      } else if (this.actionType === 'EXTERNAL' && !IsNullOrEmpty(this.linkURL)) {
        showExternalURL(this.linkURL)
       } else if (this.actionType === 'APP_NAVIGATION' || this.actionType === 'HOME') {
        this.$f7.views.main.router.navigate(`/${this.linkURL}`)
      }
    }
  }
}
</script>
<template>
  <div class="button-wrapper" v-if="caption !== ''">
    <f7-button v-if="actionType === 'PHONE' && isUserActionAllow" v-tel="linkURL" class="external" :big="elementSize === 'large'" :outline="elementStyle == 'outlined'" :fill="elementStyle == 'filled'">{{caption}}</f7-button>
    <f7-button v-else-if="actionType === 'EMAIL' && isUserActionAllow" v-mailto="linkURL" class="external" :big="elementSize === 'large'" :outline="elementStyle == 'outlined'" :fill="elementStyle == 'filled'">{{caption}}</f7-button>
    <f7-button v-else :big="elementSize === 'large'" :outline="elementStyle == 'outlined'" :fill="elementStyle == 'filled'"  @click="onClick()">{{caption}}</f7-button>
  </div>
</template>
<style scoped>
  .button-wrapper{
    padding: 10px 15px;
  }
  .ios .button.button-small, .ios .button.button-small-ios, .md .button {
    text-transform: none;
  }
  .button {
    border-radius: 10px!important;
  }
  .button-small {
    margin: 0 25%!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/Button.vue